import React, { Component } from 'react'
import Formsy from 'formsy-react'
import { TextFieldFormsy } from '@fuse'
import { withStyles, Button, Divider, Typography, InputAdornment, Icon } from '@material-ui/core'
import { bindActionCreators } from 'redux'
import * as FuseActions from 'store/actions'
import * as Actions from 'auth/store/actions'
import { withRouter } from 'react-router-dom'
import connect from 'react-redux/es/connect/connect'
import _ from '@lodash'

const styles = theme => ({
  root: {
    width: '100%'
  }
})

class CustomJWTLoginTab extends Component {
    state = {
      canSubmit: false
    };

    form = React.createRef();

    disableButton = () => {
      this.setState({ canSubmit: false })
    };

    enableButton = () => {
      this.setState({ canSubmit: true })
    };

    onSubmit = (model) => {
      this.props.submitLoginSimple(model)
    };

    componentDidUpdate (prevProps, prevState) {
      const { showMessage } = this.props
      if (this.props.login.error && (this.props.login.error.email || this.props.login.error.password)) {
        this.form.updateInputsWithError({
          ...this.props.login.error
        })

        this.props.login.error = null
        this.disableButton()
      }

      if (!_.isEqual(prevProps.login, this.props.login)) {
        if (!this.props.login.success) {
          showMessage({ message: 'Credenziali errate!', variant: 'error' })
        }
      }

      return null
    }

    render () {
      const { classes } = this.props
      const { canSubmit } = this.state

      return (
        <div className={classes.root}>
          <Formsy
            onValidSubmit={this.onSubmit}
            onValid={this.enableButton}
            onInvalid={this.disableButton}
            ref={form => this.form = form}
            className='flex flex-col justify-center w-full'
          >
            <TextFieldFormsy
              className='mb-16'
              type='text'
              name='username'
              label='Username'
              validations={{
                minLength: 4
              }}
              validationErrors={{
                minLength: 'Min character length is 4'
              }}
              InputProps={{
                endAdornment: <InputAdornment position='end'><Icon className='text-20' color='action'>email</Icon></InputAdornment>
              }}
              variant='outlined'
              required
            />

            <TextFieldFormsy
              className='mb-16'
              type='password'
              name='password'
              label='Password'
              validations={{
                minLength: 4
              }}
              validationErrors={{
                minLength: 'Min character length is 4'
              }}
              InputProps={{
                endAdornment: <InputAdornment position='end'><Icon className='text-20' color='action'>vpn_key</Icon></InputAdornment>
              }}
              variant='outlined'
              required
            />

            <Button
              type='submit'
              variant='contained'
              color='primary'
              className='w-full mx-auto mt-16 normal-case'
              aria-label='LOG IN'
              disabled={!canSubmit}
              value='legacy'
            >
                        Login
            </Button>

          </Formsy>

        </div>
      )
    }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    submitLoginSimple: Actions.submitLoginSimple,
    setUserData: Actions.setUserData,
    showMessage: FuseActions.showMessage
  }, dispatch)
}

function mapStateToProps ({ auth }) {
  return {
    login: auth.login,
    user: auth.user
  }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomJWTLoginTab)))
